/* eslint-disable @typescript-eslint/no-explicit-any */
import { inject } from '@angular/core';
import {
  HttpRequest,
  HttpEvent,
  HttpErrorResponse,
  HttpHandlerFn
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { GlobalFacade } from '~app/app/~store/facades/global.facade';
import { SnackbarService } from '~app/app/~shared/services/snackbar.service';
import { SKIP_ERROR_INTERCEPTOR } from '~app/app/~shared/constants/global.constants';
import { extractFromRequestData, getErrorMessage } from '../utils/utils';

export function httpErrorsInterceptor(
  request: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> {
  const globalFacade = inject(GlobalFacade);
  const snackbarService = inject(SnackbarService);
  const { request: req, value: useStateFormViolationHandler } =
    extractFromRequestData<boolean>(request, 'useStateFormViolationHandler');

  const { value: skipErrorInterceptor } = extractFromRequestData<boolean>(
    request,
    'skipErrorInterceptor'
  );
  return next(req).pipe(
    tap({
      error: error => {
        if (useStateFormViolationHandler) {
          globalFacade.handleFormViolations(error);
        }
      }
    }),
    catchError((error: HttpErrorResponse) => {
      if (
        request.context.get(SKIP_ERROR_INTERCEPTOR) === true ||
        skipErrorInterceptor
      ) {
        return throwError(() => error);
      }
      snackbarService.open({
        text: getErrorMessage(error)
      });

      return throwError(() => error);
    })
  );
}
